module.exports = __webpack_public_path__ + "img/complete_btn.f6213de4.png";